import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import AddToQueueIcon from "@mui/icons-material/AddToQueue";
import PreviewIcon from "@mui/icons-material/Preview";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ApprovalIcon from "@mui/icons-material/Approval";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import BarChartIcon from "@mui/icons-material/BarChart";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import EditIcon from '@mui/icons-material/Edit';
import ExpandMore from "@mui/icons-material/ExpandMore";
import List from "@mui/material/List";

export default function MainListItems() {
  const [openUsers, setOpenUsers] = useState(false);

  const handleUsersMenu = () => {
    setOpenUsers(!openUsers);
  };
  const level = JSON.parse(sessionStorage.getItem("userDetails")).level;
  const { pathname } = useLocation();
  return (
    <React.Fragment>
      {level === 3 ? (
        <ListItemButton
          component={Link}
          to="/create"
          selected={pathname === "/create-request"}
        >
          <ListItemIcon>
            <AddToQueueIcon />
          </ListItemIcon>
          <ListItemText primary="Create Request" />
        </ListItemButton>
      ) : null}
      {level === 3 ? (
        <ListItemButton
          component={Link}
          to="/edit-request"
          selected={pathname === "/edit-request"}
        >
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <ListItemText primary="Edit Request" />
        </ListItemButton>
      ) : null}
      {level === 3 ? (
        <ListItemButton
          component={Link}
          to="/add-validation"
          selected={pathname === "/add-validation"}
        >
          <ListItemIcon>
            <AddToQueueIcon />
          </ListItemIcon>
          <ListItemText primary="Add Validation" />
        </ListItemButton>
      ) : null}
      {level === 0 ? (
        <ListItemButton
          component={Link}
          to="/log-request"
          selected={pathname === "/log-request"}
        >
          <ListItemIcon>
            <AssignmentIcon />
          </ListItemIcon>
          <ListItemText primary="Log Request" />
        </ListItemButton>
      ) : null}

      <ListItemButton
        component={Link}
        to="/view-request"
        selected={pathname === "/view-request"}
      >
        <ListItemIcon>
          <PreviewIcon />
        </ListItemIcon>

        <ListItemText primary="View Request" />

        {/* {openViewRequest ? <ExpandLess /> : <ExpandMore />} */}
      </ListItemButton>
      {level === 1 || level === 2 || level === 3 ? (
        <ListItemButton
          component={Link}
          to="/approvals"
          selected={pathname === "/approvals"}
        >
          <ListItemIcon>
            <ApprovalIcon />
          </ListItemIcon>
          <ListItemText primary="Approvals" />
        </ListItemButton>
      ) : null}
      {level === 3 ? (
        <>
          <ListItemButton onClick={handleUsersMenu}>
            <ListItemIcon>
              <SupervisedUserCircleIcon />
            </ListItemIcon>
            <ListItemText primary="Users" />
            {openUsers ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openUsers} timeout="auto">
            <List component="div" disablePadding>
              <ListItemButton
                component={Link}
                to="/create-users"
                selected={pathname === "/create-users"}
              >
                <ListItemIcon>
                  <BarChartIcon />
                </ListItemIcon>
                <ListItemText primary="Add Users" />
              </ListItemButton>
              <ListItemButton
                component={Link}
                to="/map-users"
                selected={pathname === "/map-users"}
              >
                <ListItemIcon>
                  <AccountTreeOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Map Users" />
              </ListItemButton>
            </List>
          </Collapse>
        </>
      ) : null}
    </React.Fragment>
  );
}
